import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Her route değişikliğinde sayfayı en üste scroll et
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // smooth yerine instant kullandık, daha hızlı
    });
  }, [location.pathname]);

  return (
    <div className="layout">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;

